import { FormModal } from "../base";
import { StartupSettingsForm, StartupSettingsFormData } from "./StartupSettingsForm";

type StartupSettingsDialogProps = {
  isOpen: boolean;
  onClose: () => void;
  config: StartupSettingsFormData;
  onSave: (config: StartupSettingsFormData) => void;
  organizationId: string;
};

export const StartupSettingsDialog = ({ isOpen, onClose, config, onSave, organizationId }: StartupSettingsDialogProps) => {
  return (
    <FormModal
      isOpen={isOpen}
      onClose={onClose}
      onSave={onSave}
      config={config}
      title="Startup Settings"
      saveLabel="Save & Deploy"
    >
      {({ localConfig, onChange }) => (
        <StartupSettingsForm
          config={localConfig}
          onChange={onChange}
          organizationId={organizationId}
        />
      )}
    </FormModal>
  );
};
